
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/free-books",
      function () {
        return require("private-next-pages/free-books/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/free-books"])
      });
    }
  